import { useAuth } from "@/context/auth/AuthContext";
import { useTranslation } from "react-i18next";
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";

type CopyFromMasterFieldProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
};

const CopyFromMasterField = ({
  checked,
  onCheckedChange,
}: CopyFromMasterFieldProps) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isReader = user?.role === "reader";

  return (
    <div className="flex flex-col gap-2 rounded-md border border-border p-4">
      <div className="flex items-start gap-3">
        <Checkbox
          id="copyFromMaster"
          checked={checked}
          onCheckedChange={(value) => onCheckedChange(value === true)}
          disabled={isReader}
        />
        <div className="flex flex-col gap-1">
          <Label htmlFor="copyFromMaster" className="font-medium leading-snug">
            {t("copyFromMaster.label")}
          </Label>
          <p className="text-sm text-muted-foreground">
            {t("copyFromMaster.hint")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CopyFromMasterField;
